import { Component } from '@angular/core';

@Component({
  selector: 'app-mini-loading1',
  templateUrl: './mini-loading1.component.html',
  styleUrls: ['./mini-loading1.component.scss']
})
export class MiniLoading1Component{


}
